export default {
    section: 'Document Request',
    name: 'employee-owner-document-request',
    questionWidth: 12,
    items: [
        {
            text: 'In advance of our first call, it is helpful for our team to have copies of the following documents (to the extent that you have any/all available)',
            type: 'data-table',
            name: 'employee-owner-documents',
            props: {
                questionWidth: 12,
                headers: [
                    {
                        text: 'File Name',
                        value: 'filename'
                    },
                    {
                        text: 'File Size',
                        value: 'filesize'
                    }
                ],
                isFileUpload: true,
                newItemLabel: 'Upload a File',
                noDataLabel: 'Please Upload a Document'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/employee-owner/valuation-data/document-request.js